import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils';
export function FormLabel({ htmlFor, children, hidden }) {
    return (_jsx("label", { htmlFor: htmlFor, className: cn('text-sm text-gray-800 font-medium text-nowrap', {
            'sr-only': hidden,
        }), children: children }));
}
